import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { useIntl } from 'react-intl';
import PropTypes from 'prop-types';
import DateFnsUtils from '@date-io/date-fns';
import { MuiPickersUtilsProvider, DatePicker } from '@material-ui/pickers';
import { InputAdornment, IconButton } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import styles from '../../assets/jss/components/datePickerStyle';
import { Calendar } from '../Icons/Icon';
import {
    localeMap,
    localeCancelLabelMap,
} from '../../common/Constants';

const useStyles = makeStyles(styles);

/**
 * https://material-ui-pickers.dev/api/DatePicker
 */
const SingleDatePickerSearch = (props) => {
    const {
        defaultValue,
        onChange,
        format,
        locale,
        error,
        ...rest
    } = props;

    const [selectedDate, setSelectedDate] = useState(new Date());
    const intl = useIntl();

    useEffect(() => {
        setSelectedDate(defaultValue);
    }, [defaultValue]);

    const handleDateChange = (date) => {
        setSelectedDate(date);
        if (onChange) {
            onChange(date);
        }
    };
    const classes = useStyles(props);

    return (
        <MuiPickersUtilsProvider utils={DateFnsUtils} locale={localeMap[locale]}>
            <DatePicker
                format="yyyy/MM/dd"
                // autoOk
                invalidDateMessage
                invalidLabel
                maxDateMessage
                minDateMessage
                error={error}
                variant="outlined"
                inputVariant="outlined"
                value={selectedDate}
                onChange={handleDateChange}
                cancelLabel={localeCancelLabelMap[locale]}
                clearLabel={intl.formatMessage({ id: 'datepicker.clear' })}
                clearable
                // KeyboardButtonProps={{
                //     'aria-label': 'change date',
                // }}
                InputProps={{
                    endAdornment: (
                        <InputAdornment position="end">
                            <IconButton
                                aria-label="input"
                                onClick={() => {}}
                                edge="end"
                                tabIndex={-1}
                            >
                                <Calendar />
                            </IconButton>
                        </InputAdornment>
                    ),
                }}
                inputProps={{ className: classes.inputDatePicker }}
                maxDate={new Date('9999/12/31')}
                minDate={new Date('0001/01/01')}
                {...rest}
            />
        </MuiPickersUtilsProvider>
    );
};

SingleDatePickerSearch.defaultProps = {
    defaultValue: new Date(),
    format: 'yyyy-MM-dd',
    locale: 'ja',
    error: false,
};

SingleDatePickerSearch.propTypes = {
    defaultValue: PropTypes.string,
    onChange: PropTypes.func.isRequired,
    format: PropTypes.string,
    locale: PropTypes.string,
    error: PropTypes.bool,
};

const mapStateToProps = (state) => ({
    locale: state.locale.lang.current,
});

const mapDispatchToProps = () => ({});

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(SingleDatePickerSearch);
